"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentPreview = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var classnames = require("classnames");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var preview_1 = require("utils/preview");
var Icon_1 = require("components/Icon");
var mobile_1 = require("@caddigital/sok-ui/lib/utils/mobile");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var isIE = mobile_1.isIE10 || mobile_1.isIE11;
exports.DocumentPreview = (0, recompose_1.pure)(function (props) {
    if (/\.(doc|docx|ppt|pps|pptx|xls|xlsx|xlsm)$/i.test(props.revision.name)) {
        var url = (0, preview_1.createLink)(props.revision, '', true, props.token);
        return (React.createElement("iframe", { className: classnames('iframe-style', 'office365', isIE && 'ie11'), src: url },
            React.createElement(GenericErrorMessage_1.default, { key: 'empty-folder', icon: React.createElement(Icon_1.Icon, { className: "fa-exclamation-triangle" }), title: (0, translation_1.getLocalization)('filesPreview/preview/excel/dearSokoProUser') }, (0, translation_1.getLocalization)('filesPreview/preview/excel/previewIsNotAvailable'))));
    }
    return (React.createElement(GenericErrorMessage_1.default, { icon: React.createElement(Icon_1.Icon, { className: "fa-exclamation-triangle" }), title: (0, translation_1.getLocalization)('filesPreview/preview/dwg/dearSokoProUser') }, (0, translation_1.getLocalization)('filesPreview/preview/error/previewIsNotSupported')));
});
exports.default = exports.DocumentPreview;
